import PubSub from "underpub-js";

var ListingAppFolio = function(options) {

	this.options = {
		$el: false,
		baseClass: 'comp-ListingAppFolio',
	};

	$.extend(true, this.options, options);

};

ListingAppFolio.prototype.init = function() {

	var self = this;

	this.$listings = this.options.$el.find(`.el-UnitListingCard`);

	this.$listings.on('click', function() {

		var unitId = $(this).data('unitId');

		self.showUnitModal(unitId);

	});

	// if unit url parameter exists, open modal on page load
	var currentUrl = window.location.href;
	
	if (currentUrl.indexOf("unitDetail")) {

		var urlSegments = currentUrl.split('?');

		if (urlSegments.length > 1) {

			var urlParameters = urlSegments[1].split('&');

			for (var i = 0; i < urlParameters.length; i++) {
				
				if (urlParameters[i].indexOf("unitDetail") == 0) {

					var unitId = urlParameters[i].split('=')[1];

					// make sure we don't open our modal onload from multiple components
					if (!window.unitDetailOpenedOnload) {
						console.log('ListingAppFolio:showmodal');
						window.unitDetailOpenedOnload = true;
						self.showUnitModalWhenLoaded(unitId);
					}

				}

			}

		}

	}

};

ListingAppFolio.prototype.showUnitModalWhenLoaded = function(unitId) {

	var self = this;

	if (!window.modalUnitDetailLoaded) {

		setTimeout(function() {
			self.showUnitModalWhenLoaded(unitId);
		}, 50);
		
	}
	else {

		self.showUnitModal(unitId);

	}

};

ListingAppFolio.prototype.showUnitModal = function(unitId) {

	var self = this;

	// open up the modal in loading state
	PubSub.publish('ModalUnitDetail:open', unitId);

	// put our data together
	var data = { appFolioId: unitId }
	// data[window.csrfTokenName] = window.csrfTokenValue;

	// run the ajax query that gets our unit data
	$.ajax({

		type: 'get',
		dataType: 'json',
		url: '/actions/app-folio-listings/appfolio-listings/get-detailed-listing-json',
		data: data,

		success: function(data) {

			console.log('success');
			console.log(data);

			// parse data to pass to modal

			if (!data) {
				PubSub.publish('ModalUnitDetail:notFound');
				return;
			}

			// amenities
			var amenities = [];

			for (var i = 0; i < data.amenities.length; i++) {
				amenities.push({
					"amenityText": data.amenities[i]
				});
			}

			// pet policies
			var petPolicies = [];

			for (var i = 0; i < data.petPolicies.length; i++) {
				petPolicies.push({
					"petPolicyText": data.petPolicies[i]
				});
			}

			// assemble modal data
			var modalData = {
				"id": data.id,
				"url": window.location.protocol + '//' + window.location.hostname+ '/unit/' + unitId,
				"title": data.address,
				"unitAmenities": amenities,
				"unitApplicationFee": data.applicationFee,
				"unitApplyUrl": data.applyUrl,
				"unitActive": true,
				"unitAvailability": data.availability,
				"unitBaths": data.baths,
				"unitBeds": data.beds,
				"unitCost": data.cost,
				"unitImages": data.images,
				"unitPetPolicies": petPolicies,
				"unitSecurityDeposit": data.securityDeposit,
				"unitSquareFeet": data.squareFeet,
				"unitYoutubeVideoId": data.youtubeId,
			};

			PubSub.publish('ModalUnitDetail:populateContent', modalData);

			console.log(modalData);

		},

		error: function(data) {
			console.log('ajax error');
			console.log(data);
		},

	});

};




export default ListingAppFolio;
